import { Component, OnInit, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
import { ConfigService } from 'src/app/utils/config/config.service';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { ModalDeleteComponent } from 'src/app/utils/modal-delete/modal-delete.component';
import { SesionService } from 'src/app/utils/sesion/sesion.service';
import { TipoActualizacionService } from '../../tipo-actualizacion/tipo-actualizacion.service';
import { ActualizacionStockCreateComponent } from '../actualizacion-stock-create/actualizacion-stock-create.component';
import { ActualizacionStockViewComponent } from '../actualizacion-stock-view/actualizacion-stock-view.component';
import { ActualizacionStockService } from '../actualizacion-stock.service';

@Component({
  selector: 'app-actualizacion-stock-index',
  templateUrl: './actualizacion-stock-index.component.html',
  styles: [
  ]
})
export class ActualizacionStockIndexComponent implements OnInit {

  url: string = '';

  reloadEmitter: EventEmitter<string> = new EventEmitter();

  filtros = [
    {
      label: 'Desde',
      column: 'fecha',
      op: 'gte',
      type: 'date'
    },
    {
      label: 'Hasta',
      column: 'fecha',
      op: 'lte',
      type: 'date'
    },
    {
      label: 'Tipo de Actualización',
      column: 'tipo_actualizacion_id',
      op: 'eq',
      type: 'select',
      options: [] as { label: string; value: number; }[],
    },
    {
      label: 'Detalle',
      column: 'detalle',
      op: 'substring'
    }
  ]

  acciones = [
    {
      label: 'Detalle',
      icon: 'eye',
      action: (element: any) => {
        this.view(element);
      }
    },
    {
      icon: "trash",
      label: "Eliminar",
      action: (element: any) => {
        this.delete(element);
      }
    }
  ]

  columnas = [
    {
      label: 'Fecha',
      attribute: 'fecha',
      width: 1,
      responsive: ['XS', 'SM', 'MD'],
      value: (element: any) => {
        return this.formatter.dateFormat(element.fecha);
      }
    },
    {
      label: 'Productos',
      attribute: 'producto',
      width: 2,
      responsive: ['SM', 'MD'],
      value: (element: any) => {
        return element.linea_actualizaciones.map((p: any) => p.stock.producto.nombre).join(', ');
      }
    },
    {
      label: 'Tipo de Actualización',
      attribute: 'tipo_actualizacion',
      width: 2,
      responsive: ['SM', 'MD'],
      value: (element: any) => {
        return element.tipo_actualizacion.nombre;
      }
    },
    {
      label: 'Detalle',
      attribute: 'detalle',
      width: 2,
      responsive: ['MD'],
      value: (element: any) => {
        return element.detalle;
      }
    }
  ]

  constructor(
    public config: ConfigService,
    private modalService: NgbModal,
    public loading: LoadingService,
    private alerts: AlertService,
    public service: ActualizacionStockService,
    public sesion: SesionService,
    public formatter: FormatterService,
    private tipoActualizacionService: TipoActualizacionService
  ) {
    this.loadTipoActualizacion();
  }

  ngOnInit(): void {
    this.url = this.config.apiUrl + this.service.controller + 'ver';
  }

  loadData(): void {
    this.reloadEmitter.emit();
  }

  loadTipoActualizacion(): void {
    this.loading.show();
    this.tipoActualizacionService.select().subscribe({
      next: (res: any[]) => {
        this.loading.hide();
        for (let i = 0; i < res.length; i++) {
          this.filtros[2].options?.push({ label: res[i].nombre, value: res[i].id });
        }
      },
      error: (err) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo cargar la lista de tipo de actualizaciones.", "danger");
      }
    });
  }

  add(): void {
    const modalRef = this.modalService.open(ActualizacionStockCreateComponent, { windowClass: 'clear-modal', size: 'xl', scrollable: true, backdrop: 'static' });
    modalRef.result.then((result: any) => {
      this.loadData();
    }, (reason: any) => { });
  }

  view(element: any): void {
    const modalRef = this.modalService.open(ActualizacionStockViewComponent, { windowClass: 'clear-modal', size: 'lg', scrollable: true });
    modalRef.componentInstance.element = element;
    modalRef.result.then((result: any) => {
      this.loadData();
    }, (reason: any) => { });
  }

  delete(element: any): void {
    const modalRef = this.modalService.open(ModalDeleteComponent, { windowClass: 'clear-modal', size: 'md', scrollable: true, backdrop: 'static' });
    modalRef.componentInstance.texto = `¿Seguro que desea eliminar la actualización de stock #${element.id} con fecha ${this.formatter.dateFormat(element.fecha)}?`;
    modalRef.componentInstance.textoAceptar = 'Eliminar';
    modalRef.result.then((result) => {
      this.loading.show();
      this.service.delete(element.id).subscribe({
        next: (res: any) => {
          this.loading.hide();
          this.loadData();
          this.alerts.addAlert("Registro de Actualización de Stock eliminado con éxito.", "success");
        },
        error: (err: any) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se ha podido eliminar el registro de Actualización de Stock.", "danger");
        }
      });
    }, (reason) => { });
  }
}
